import "./App.css";
import RouteIndex from "./App/Routes/RouteIndex";
function App() {
    // const { isDarkMode, setIsDarkMode } = useGeneralStore();

    // useEffect(() => {
    //     if (!("color-theme" in localStorage))
    //         localStorage.setItem("color-theme", "dark");
    //     else if (
    //         localStorage.getItem("color-theme") === "dark" ||
    //         (!("color-theme" in localStorage) &&
    //             window.matchMedia("(prefers-color-scheme: dark)").matches)
    //     ) {
    //         document.documentElement.classList.add("dark");
    //         setIsDarkMode(true);
    //     } else {
    //         document.documentElement.classList.remove("dark");
    //         setIsDarkMode(false);
    //     }
    // }, [isDarkMode, localStorage.getItem("color-theme")]);

    return (
        <div className="dark:bg-cDarkMainBG dark:text-white bg-cMainBG min-h-screen font-montserrat">
            <RouteIndex />
        </div>
    );
}

export default App;
